import './RotationLock.scss';

import { defineComponent, h, PropType } from 'vue';

import FloatingText from './FloatingText';
import { Background } from '../Colours';

export default defineComponent({
    props: {
        text: { required: true, type: String },
        background: { required: true, type: String as PropType<Background> },
    },

    render() {
        return h('div', {
            id: 'rotation-lock',
            class: {
                light: this.background === Background.white,
            },
        }, h(FloatingText, { variant: 'brand' }, () => this.text));
    },
});
